import { render, staticRenderFns } from "./_workFloNeeds.vue?vue&type=template&id=1e90d902&scoped=true&"
import script from "./_workFloNeeds.vue?vue&type=script&lang=js&"
export * from "./_workFloNeeds.vue?vue&type=script&lang=js&"
import style0 from "./_workFloNeeds.vue?vue&type=style&index=0&id=1e90d902&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90d902",
  null
  
)

export default component.exports